<template>
  <div class='CardResumo'>
    <div class='valor'>{{ valor }}</div>
    <div class='label'>{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'CardResumo',
  props: {
    label: { type: String, required: true },
    valor: { type: [String, Number], required: true }
  }
}
</script>

<style scoped>
.CardResumo {
  flex: 1;
  min-width: 0;
  padding: 16px 12px;
  border-right: 1px solid #e5e5e5;
}
.CardResumo:last-child {
  border-right: none;
}
.valor {
  font-size: 18px;
  color: #303030;
}
.label {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.3;
  color: #303030;
}
</style>
